// Status -> progress/message mapping for design/preview generation, kept in sync
// with the canvas placeholder (see globalLoadingMessage in ImageElement.jsx) so
// all loading UIs (minimized overlay, World page bar, etc.) always agree
export const DESIGN_STATUS_MESSAGES = {
  'pending':                    { progress: 5,   message: 'Please Wait...' },
  'pending2':                   { progress: 5,   message: 'Please Wait....' },
  'processing':                 { progress: 5,   message: 'Please Wait.....' },
  'savingTextElements':         { progress: 15,  message: 'Saving Text Elements...' },
  'updatingTextElements':       { progress: 16,  message: 'Updating Text Elements...' },
  'updatingTextElements2':      { progress: 17,  message: 'Updating Text Elements...' },
  'textElementsCreated':        { progress: 20,  message: 'Text Elements Created...' },
  'received':                   { progress: 30,  message: 'Request Received...' },
  'initializing':               { progress: 40,  message: 'Initializing image generation...' },
  'generatingCharacter':        { progress: 50,  message: 'Generating Character Details...' },
  'generatingImagePrompts':     { progress: 65,  message: 'Generating Image Prompts...' },
  'generatingCoverImage':       { progress: 80,  message: 'Generating Cover Image...' },
  'updatingImageElements':      { progress: 85,  message: 'Updating Image Elements...' },
  'updatedTextElementsInterior':{ progress: 85,  message: 'Finalizing Text Elements...' },
  'updatedCoverImage':          { progress: 90,  message: 'Finalizing Cover Image...' },
};

// Statuses that mean the design/preview generation is still in progress
export const ACTIVE_DESIGN_STATUSES = new Set(Object.keys(DESIGN_STATUS_MESSAGES));
